export default __webpack_public_path__ + "app/images/theme-images/dark/ic-alert/icon-24-alert@2x.webp";